<template>
  <div>
    <v-row v-show="false">
      <v-col cols="12">
        <v-btn
          color="cyan darken-4"
          v-shortkey.once="['f1']"
          @shortkey="carregarCambios()"
          class="white--text"
        >
          Carregar
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <span
            class="text-h5 font-weight-thin black--text"
            style="user-select: none"
            >Câmbio</span
          >
          <span
            class="text-h5 font-weight-light green--text text--darken-1"
            style="user-select: none"
            color="red"
            >atual</span
          >
        </div>
        <v-data-table
          dense
          dark
          hide-default-footer
          :headers="headerList"
          :items="currency"
          :loading="loadingItems"
          :show-select="false"
          :single-select="false"
          item-key="DATAHORA"
          no-data-text="Sem registros para exibir"
        >
          <template v-slot:item.DATAHORA="{ item }">
            {{ formatDate(item.DATAHORA) }}
          </template>
          <template v-slot:item.CAMBIO0="{ item }">
            {{ formatCurrency(0, item.CAMBIO0) }}
          </template>
          <template v-slot:item.CAMBIO1="{ item }">
            {{ formatCurrency(1, item.CAMBIO1) }}
          </template>
          <template v-slot:item.CAMBIO2="{ item }">
            {{ formatCurrency(2, item.CAMBIO2) }}
          </template>
          <template v-slot:item.CAMBIO3="{ item }">
            {{ formatCurrency(3, item.CAMBIO3) }}
          </template>
          <template v-slot:item.CAMBIO4="{ item }">
            {{ formatCurrency(4, item.CAMBIO4) }}
          </template>
          <template v-slot:item.CAMBIO5="{ item }">
            {{ formatCurrency(5, item.CAMBIO5) }}
          </template>
          <template v-slot:item.controls="props">
            <v-btn-toggle tile>
              <!-- <v-btn class="mr-1" fab x-small color="warning" @click="goToRoute(props.item)">
                            <v-icon dark>mdi-pen</v-icon>
                        </v-btn> -->
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="doDelete(props.item)"
                :disabled="opering"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div>
          <span
            class="text-h5 font-weight-thin black--text"
            style="user-select: none"
            >Câmbios</span
          >
          <span
            class="text-h5 font-weight-light green--text text--darken-1"
            style="user-select: none"
            >anteriores</span
          >
        </div>
        <v-data-table
          dense
          dark
          hide-default-footer
          :headers="headerList"
          :items="currencyList"
          :loading="loadingItems"
          :show-select="false"
          :single-select="false"
          item-key="DATAHORA"
          no-data-text="Sem registros para exibir"
        >
          <template v-slot:item.DATAHORA="{ item }">
            {{ formatDate(item.DATAHORA) }}
          </template>
          <template v-slot:item.CAMBIO0="{ item }">
            {{ formatCurrency(0, item.CAMBIO0) }}
          </template>
          <template v-slot:item.CAMBIO1="{ item }">
            {{ formatCurrency(1, item.CAMBIO1) }}
          </template>
          <template v-slot:item.CAMBIO2="{ item }">
            {{ formatCurrency(2, item.CAMBIO2) }}
          </template>
          <template v-slot:item.CAMBIO3="{ item }">
            {{ formatCurrency(3, item.CAMBIO3) }}
          </template>
          <template v-slot:item.CAMBIO4="{ item }">
            {{ formatCurrency(4, item.CAMBIO4) }}
          </template>
          <template v-slot:item.CAMBIO5="{ item }">
            {{ formatCurrency(5, item.CAMBIO5) }}
          </template>
          <template v-slot:item.controls="props">
            <v-btn-toggle tile>
              <!-- <v-btn class="mr-1" fab x-small color="warning" @click="openRegister(props.item)">
                            <v-icon dark>mdi-pen</v-icon>
                        </v-btn> -->
              <v-btn
                class="rounded"
                fab
                x-small
                color="red accent-4"
                @click="doDelete(props.item)"
                :disabled="opering"
              >
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </v-btn-toggle>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-btn
      v-shortkey.once="['alt', 'r']"
      @shortkey="openRegister()"
      v-show="false"
    />
    <confirm ref="confirm" v-model="confirm" />
    <router-view />
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import Confirm from '@/components/shared/base-dialog/Confirm.vue'
export default {
  components: { Confirm },
  mixins: [tableMixin, currencyMixin],
  data: () => {
    return {
      query: { ultimo: '' },
      confirm: false,
    }
  },
  mounted() {
    this.carregarCambios()
  },
  computed: {
    ...mapGetters({ getCurrencies: 'systemModule/getSystemCurrencies' }),
    ...mapState('currencyModule', [
      'currencyList',
      'currency',
      'loadingItems',
      'opering',
    ]),
    headerList() {
      const header = []
      header.push({ text: 'Data', value: 'DATAHORA', width: 180 })
      this.getCurrencies.forEach((element, index) => {
        header.push({ text: element.descricao, value: `CAMBIO${index}` })
      })
      header.push({ text: 'Ações', value: 'controls', width: 100 })
      return header
    },
  },
  methods: {
    ...mapActions({
      getCurrencyAPI: 'currencyModule/getCurrency',
      deleteCurrency: 'currencyModule/deleteCurrency',
    }),
    async carregarCambios() {
      try {
        await this.getCurrencyAPI({ ultimo: 'S' })
        await this.getCurrencyAPI({ ultimo: '' })
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    formatDate(date, withTime = false) {
      let dateTimeArray = date.split(' ')
      let dateArray = dateTimeArray[0].split('-')
      let timeArray = dateTimeArray[1].split(':')
      if (withTime)
        return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]} ${timeArray[0]}h${timeArray[1]}m${timeArray[2]}`
      else return `${dateArray[2]}/${dateArray[1]}/${dateArray[0]}`
    },
    openRegister() {
      this.$router.push({ name: 'cambio.register' })
    },
    async doDelete(item) {
      try {
        if (
          await this.$refs.confirm.open(
            'Exclusão',
            `Deseja realmente eliminar o cambio de ${this.formatDate(
              item.DATAHORA
            )}?`,
            { color: 'red darken-3' }
          )
        ) {
          let response = await this.deleteCurrency(item)
          this.$toasted.success(response)
        } else {
          return
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
  },
}
</script>

<style></style>
